import convertLngLat from '@gaia/utils/mapbox/convertLngLat';
import filter from 'lodash/filter';
import maxBy from 'lodash/maxBy';
import values from 'lodash/values';

import fetchRoutedLine from './fetchRoutedLine';

const unresolvableLine = new Promise<GeoJSON.LineString>(() => {});

export default function getAppendPreviewRequest(
    track: Track,
    interaction: InteractionState | undefined,
    project: MapProject
): TrackLineRequest | undefined {
    if (!track.isGeometryLoaded) throw new Error();

    const fromPoint = maxBy(
        filter(
            values(track.points),
            (point) => !point.properties.archived && !point.properties.deleted
        ),
        (point) => point.properties.order
    );

    if (!fromPoint) return;

    if (!interaction) return;
    if (interaction.subtype !== 'appendingPoint') return;
    if (interaction.type === 'editingArea') return;
    if (interaction.track.properties.localId !== track.properties.localId) return;
    if (!interaction.cursorLngLat) return;

    const fromLngLat = convertLngLat(fromPoint.geometry.coordinates);
    const toLngLat = convertLngLat(interaction.cursorLngLat.toArray());
    const costing = track.properties.routing_mode;

    const properties: TrackLineRequest['properties'] = {
        fromPointLocalId: fromPoint.properties.localId,
        toPointLocalId: undefined,
        lineLocalId: 'appendPreview',
        localId: track.properties.localId,
        type: 'preview',
        id: track.properties.id,
    };

    const loadingGeometry: GeoJSON.LineString = {
        type: 'LineString',
        coordinates: [],
    };

    if (interaction.idle) {
        return {
            type: 'async',
            properties,
            loadingGeometry,
            geometry: fetchRoutedLine({
                fromLngLat,
                toLngLat,
                project,
                costing,
                omitElevation: true,
            }),
        };
    } else {
        return {
            type: 'async',
            properties,
            loadingGeometry,
            geometry: unresolvableLine,
        };
    }
}
